import React, { useEffect, useState } from 'react';
import { useGetForm } from 'new/hooks/useGetForm';
import { Form, ReusableTransformType } from '@nexla/@types';
import AttributeTransformList from 'src/new/components/ReusableTransform/AttributeTransformList';
import { FORM_TYPE_CREATE_REUSABLE_TX as FormKey } from 'js/constants/formTypes';
import { TransformDataForm, TransformType } from 'new/components/ReusableTransform/types';
import './AttributeTransforms.scss';
import { SearchModal } from 'new/elements/SearchModal';
import { SearchFilterViews } from 'js/constants/visibilityFilters';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_CODE_CONTAINERS_REQUEST } from 'js/constants/actionTypes';
import { getReusableTransformListing } from 'js/actions';
import { useAttributeTransforms } from './useAttributeTransforms';
import { useSelector } from 'react-redux';

type Props = {
  transformBeingEditedID?: number;
  transformsData: ReusableTransformType[];
  isFetchingReusableTransforms: boolean;
  onEditButtonClicked: (tx: string) => void;
};

function AttributeTransforms(props: Props) {
  const { transformBeingEditedID, transformsData, isFetchingReusableTransforms } = props;
  const form = useGetForm<Form<TransformDataForm>>(FormKey);
  const loadedTransforms = useAttributeTransforms(form?.data?.transformType);
  const transformsMap = useSelector((state: any) => state.entities.transforms);
  const isLoading = useIsLoading(GET_CODE_CONTAINERS_REQUEST);
  const [transformList, setTransformList] = useState([]);

  useEffect(() => {
    let list = loadedTransforms;
    if (!list.some((item) => item.id === transformBeingEditedID)) {
      list = [...loadedTransforms, transformsMap[transformBeingEditedID]];
    }
    setTransformList(list);
  }, [isFetchingReusableTransforms, transformsMap, transformBeingEditedID]);

  if (!form?.data) return null;

  const name = form?.data?.name || 'Untitled Transform';
  const isRecordTx = form?.data?.transformType === TransformType.RECORD;
  const title = isRecordTx ? 'record transforms' : 'attribute transforms';
  const view = SearchFilterViews.REUSABLE_TRANSFORMS;

  async function loadAttributeTransform(selected) {
    const { onEditButtonClicked } = props;
    onEditButtonClicked(selected);
  }

  return (
    <div className="attribute-transforms-container">
      <span className="title">{title}</span>
      <div className="search-button">
        <SearchModal
          data={transformsData}
          view={view}
          isLoading={isLoading}
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Open"
          buttonLabel="Search"
          title={`Search ${title}`}
          loadData={getReusableTransformListing}
          onConfirmButtonClick={loadAttributeTransform}
        />
      </div>
      <div className="content-list">
        <AttributeTransformList
          data={transformList}
          currentName={name}
          transformBeingEditedID={transformBeingEditedID}
          isFetchingReusableTransforms={isFetchingReusableTransforms}
        />
      </div>
    </div>
  );
}

export default AttributeTransforms;
